import React from 'react'
import ProductGrid from './ProductGrid'

const Promos = () => {
  return (
    <div id="promos" className="scroll-mt-20">
        

        <h1 className="
  text-center
  font-raleway
  font-regular
  text-2xl
  md:text-4xl
  tracking-wide
  text-gray-900
  mt-8
  md:mt-16
">
  Nos Promos
</h1>



<ProductGrid/>



    </div>
  )
}

export default Promos